import { t } from 'i18next';

import { ErrorResponseErrorItemCodeSharedFolder } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeSharedFolder, string> => ({
  'shared_folder:not_found': t('sharedFolder.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Mappen delas inte.',
  }),
  'shared_folder:file_version_not_found': t('sharedFolder.fileVersionNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Mappen delas inte.',
  }),
  'shared_folder:folder_not_found': t('sharedFolder.folderNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Mappen delas inte.',
  }),
});
